import React, { Component } from 'react'
import { infoScreenAriaLabel } from '../Constants/AriaLabelText'
import $ from 'jquery'
import { injectIntl, FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'
import { getLanguageSpecificAssetUrl } from '@vmockinc/dashboard/services/helpers'


class InfoSkills extends Component {
  handleTab(id, tabId) {
    $('.as-info-modal-wrapper')
      .find('li')
      .removeClass('active')
      .attr('aria-selected', false)
    $('.as-info-modal-wrapper').find('div').removeClass('show active')
    $(tabId).addClass('active').attr('aria-selected', true)
    $(id).addClass('show active')
  }

  render() {
    const { currentSection, intl, pdfLanguage } = this.props
    let imageLanguage = pdfLanguage
    if(pdfLanguage === 'us' || pdfLanguage === 'uk')
      imageLanguage = 'english'
    let venDiagram = getLanguageSpecificAssetUrl(`skills-write-summary-headline.png`, imageLanguage, 'images', 'aspire')
    if (currentSection == 'Headline' || currentSection == 'Summary') {
      // same no need to change
    } else if (currentSection == 'Experience') {
      venDiagram = getLanguageSpecificAssetUrl(`skills-write-experience.png`, imageLanguage, 'images', 'aspire')
    }

    return (
      <div>
        <div className="as-info-modal-wrapper">
          <div className="as-info-modal-close">
            <a
              href="javascript:void(0);"
              aria-label={infoScreenAriaLabel(intl)['close']}
              onClick={() => this.props.hideModal()}
              className="icon-cross as-profile-edit-close-btn modal-close-button"
            />
          </div>
          <div className="as-info-modal-heading">
            <FormattedMessage id="infoSkills.heading.skills" defaultMessage="Skills" />
          </div>
          <div className="as-info-modal-subheading">
            <FormattedMessage id="infoSkills.subheading.skillsImportance" defaultMessage="How and why are skills important for your LinkedIn Profile?" />
          </div>
          <div className="as-info-modal-desc">
            <FormattedMessage id="infoSkills.desc.relevantSkills" defaultMessage="Relevant skills refer to skills that are important for pursuing a career in your chosen target function(s). Including these skills in your profile makes the recruiters feel that you are a better fit for the job and increases your chances of being singled out for that job. Follow the diagram below to decide which skills to focus on." />
          </div>
          <div className="row as-info-modal-content as-info-modal-content-skills">
            <div className="col-sm-6">
              <div className="smp-bullets">
                <h4>
                  <FormattedMessage id="infoSkills.bullets.focusSkills" defaultMessage="What skills to focus on?" />
                </h4>
                <div className="text-center">
                  <img src={venDiagram} width="400px" alt="" />
                </div>
                <p className="text-normal">
                  <FormattedMessage id="infoSkills.bullets.focusSkillsDesc" defaultMessage="With our machine learning and AI engines, you can exactly know what skills are valued for the target functions you have selected. Try to focus on the intersection of what you have and what is required." />
                </p>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="smp-bullets" style={{ minHeight: "460px", height: "fit-content" }}>
                <h4>
                  <FormattedMessage id="infoSkills.bullets.writeSkills" defaultMessage="How to write about skills?" />
                </h4>
                <div className="smp-bullets-desc">
                  <FormattedMessage id="infoSkills.bullets.writeSkillsDesc" defaultMessage="Writing about skills can be done in two ways, they can be stated directly or as phrases from which the reader can derive skills. For higher visibility, try using direct forms of skills so that recruiters can easily find you." />
                </div>
                <div className="nav-content">
                  <ul 
                    className="nav nav-tabs as-info-modal-nav-tabs" 
                    role="tablist"
                    tabIndex={0}
                  >
                    <li
                      className="active"
                      id="statedSkillsTab"
                      role="presentation">
                      <a
                        role="tab"
                        aria-selected="true"
                        aria-label={
                          infoScreenAriaLabel(intl)['skill']['sample']['stated']
                        }
                        onClick={this.handleTab.bind(
                          this,
                          '#statedskills',
                          '#statedSkillsTab'
                        )}
                        aria-controls="statedskills"
                        data-bs-toggle="tab">
                        <FormattedMessage id="infoSkills.tabs.statedSkills" defaultMessage="Stated skills" />
                      </a>
                    </li>
                    <li
                      id="derivedSkillsTab"
                      role="presentation">
                      <a
                        role="tab"
                        aria-selected="false"
                        aria-label={
                          infoScreenAriaLabel(intl)['skill']['sample'][
                            'derived'
                          ]
                        }
                        onClick={this.handleTab.bind(
                          this,
                          `#derivedskills`,
                          `#derivedSkillsTab`
                        )}
                        aria-controls="derivedskills"
                        data-bs-toggle="tab">
                        <FormattedMessage id="infoSkills.tabs.derivedSkills" defaultMessage="Derived skills" />
                      </a>
                    </li>
                  </ul>
                  <div className="tab-content">
                    <div
                      role="tabpanel"
                      className="tab-pane fade show active"
                      id="statedskills">
                      <p>
                        <FormattedMessage id="infoSkills.tabs.statedSkillsDesc" defaultMessage="Stated skills are skills that are mentioned directly in your profile. Stating a relevant skill increases your SEO ranking." />
                      </p>
                      <h5
                        className="border-bottom-gray"
                        aria-label={
                          infoScreenAriaLabel(intl)['skill']['sample'][
                            'stated_ex_1'
                          ]
                        }>
                        {' '}
                        <FormattedMessage id="infoSkills.tabs.statedSkillsExample1" defaultMessage="Example 1" />
                      </h5>
                      <p>
                        <FormattedMessage id="infoSkills.tabs.statedSkillsShowcase1" defaultMessage='To showcase “Business Development” skill, you can write:' />
                      </p>
                      <p>
                        <FormattedMessage id="infoSkills.tabs.statedSkillsExampleText1" defaultMessage="Led and improved business development efforts and reduced client acquisition cost by 38%" />
                      </p>
                      <h5
                        className="border-bottom-gray"
                        aria-label={
                          infoScreenAriaLabel(intl)['skill']['sample'][
                            'stated_ex_2'
                          ]
                        }>
                        {' '}
                        <FormattedMessage id="infoSkills.tabs.statedSkillsExample2" defaultMessage="Example 2" />
                      </h5>
                      <p>
                        <FormattedMessage id="infoSkills.tabs.statedSkillsShowcase2" defaultMessage='To showcase “Recruiting” skill, you can write:' />
                      </p>
                      <p>
                        <FormattedMessage id="infoSkills.tabs.statedSkillsExampleText2" defaultMessage="Worked as HR Manager and handled recruiting of new and efficient candidates for KPMG; reduced vacancies, improving efficiency by 25%" />
                      </p>
                    </div>
                    <div
                      role="tabpanel"
                      className="tab-pane fade"
                      id="derivedskills">
                      <p
                        aria-label={
                          infoScreenAriaLabel(intl)['skill']['sample'][
                            'derived_ans'
                          ]
                        }>
                        <FormattedMessage id="infoSkills.tabs.derivedSkillsDesc" defaultMessage="Derived skills are skills that have been mentioned in such a way that the reader can infer the skill from the language used." />
                      </p>
                      <h5
                        className="border-bottom-gray"
                        aria-label={
                          infoScreenAriaLabel(intl)['skill']['sample'][
                            'derived_ex_1'
                          ]
                        }>
                        {' '}
                        <FormattedMessage id="infoSkills.tabs.derivedSkillsExample1" defaultMessage="Example 1" />
                      </h5>
                      <p>
                        <FormattedMessage id="infoSkills.tabs.derivedSkillsShowcase1" defaultMessage='To showcase “Strategy Implementation” skill, you can write:' />
                      </p>
                      <p>
                        <FormattedMessage id="infoSkills.tabs.derivedSkillsExampleText1" defaultMessage="Developed and executed Go to Market strategies, resulting in increased sales and profit" />
                      </p>
                      <h5
                        className="border-bottom-gray"
                        aria-label={
                          infoScreenAriaLabel(intl)['skill']['sample'][
                            'derived_ex_2'
                          ]
                        }>
                        {' '}
                        <FormattedMessage id="infoSkills.tabs.derivedSkillsExample2" defaultMessage="Example 2" />
                      </h5>
                      <p>
                        <FormattedMessage id="infoSkills.tabs.derivedSkillsShowcase2" defaultMessage='To showcase “Team Leadership” skill, you can write:' />
                      </p>
                      <p>
                        <FormattedMessage id="infoSkills.tabs.derivedSkillsExampleText2" defaultMessage="Led cross-functional team of Business Development, Marketing, HR and IT to design 2 CRM data-processing tools for optimum client handling" />
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state, ownProps) {
  return {
    pdfLanguage: state.aspireFeedbackData.pdf_language,
  }
}

export default connect(mapStateToProps)(injectIntl(InfoSkills))
